import React from 'react';
import "./LinkSocialNetworks.css";
import facebook from '../../Assets/Icons/facebook.svg';
import instagram from '../../Assets/Icons/instagram.svg';
import linkedin from '../../Assets/Icons/linkedin.svg';
import { Link } from 'react-router-dom';

const LinkSocialNetworks = () => {
    return (
        <div className='linkSocialNetworks'>
            <Link className='facebookImage'><img src={facebook} alt="lien vers facebook" /></Link> 
            <Link className='instagramImage'><img src={instagram} alt="lien vers instagram" /></Link>
            <Link className='linkedinImage'><img src={linkedin} alt="lien vers linkedin" /></Link>
        </div>
    )
};

export default LinkSocialNetworks;